import { render, staticRenderFns } from "./InList.vue?vue&type=template&id=656db5b2&scoped=true"
import script from "./InList.vue?vue&type=script&lang=js"
export * from "./InList.vue?vue&type=script&lang=js"
import style0 from "./InList.vue?vue&type=style&index=0&id=656db5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656db5b2",
  null
  
)

export default component.exports